import { Routes } from '@angular/router';
import { canActivateAuthRole } from 'O3_core';
import { GLOBAL_AUDIT_PROVIDERS } from '../providers/audit.providers';
import { Landing } from '../layout/landing/landing';
import { Forbidden } from '../layout/forbidden/forbidden';
import { PageNotFound } from '../layout/page-not-found/page-not-found';

export const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  { path: 'landing', component: Landing },
  {
    path: 'public/consents',
    loadComponent: () =>
      import('../layout/public-consents/consents').then((c) => c.Consents),
  },
  {
    path: 'identity',
    canActivate: [canActivateAuthRole],
    loadChildren: () => import('O3_identity').then((c) => c.routes),
  },
  {
    path: 'dashboard',
    canActivate: [canActivateAuthRole],
    loadChildren: () => import('O3_reporting').then((c) => c.routes),
  },
  {
    path: 'reporting',
    canActivate: [canActivateAuthRole],
    loadChildren: () => import('O3_reporting').then((c) => c.routes),
  },
  {
    path: 'patient-management',
    canActivate: [canActivateAuthRole],
    loadChildren: () => import('O3_patient-management').then((c) => c.routes),
  },
  {
    path: 'structure',
    canActivate: [canActivateAuthRole],
    loadChildren: () => import('O3_structure').then((c) => c.routes),
  },
  {
    path: 'system-catalogs',
    canActivate: [canActivateAuthRole],
    loadChildren: () => import('O3_system-catalogs').then((c) => c.routes),
  },
  {
    path: 'financials',
    canActivate: [canActivateAuthRole],
    loadChildren: () => import('O3_financials').then((c) => c.routes),
  },
  {
    path: 'scheduler',
    canActivate: [canActivateAuthRole],
    loadChildren: () => import('O3_scheduler').then((c) => c.routes),
  },
  {
    path: 'chemotherapy',
    canActivate: [canActivateAuthRole],
    loadChildren: () => import('O3_chemotherapy').then((c) => c.routes),
  },
  {
    path: 'radiotherapy',
    canActivate: [canActivateAuthRole],
    loadChildren: () => import('O3_radiotherapy').then((c) => c.routes),
  },
  {
    path: 'oncology-catalogs',
    canActivate: [canActivateAuthRole],
    loadChildren: () => import('O3_oncology-catalogs').then((c) => c.routes),
  },
  {
    path: 'stock-management',
    canActivate: [canActivateAuthRole],
    loadChildren: () => import('O3_stock-management').then((c) => c.routes),
  },
  {
    path: 'cnas',
    canActivate: [canActivateAuthRole],
    loadChildren: () => import('O3_cnas').then((c) => c.routes),
  },
  {
    path: 'file-storage',
    canActivate: [canActivateAuthRole],
    loadChildren: () => import('O3_file-storage').then((c) => c.routes),
  },
  {
    path: 'job-scheduler',
    canActivate: [canActivateAuthRole],
    loadChildren: () => import('O3_job-scheduler').then((c) => c.routes),
  },
  {
    path: 'notifications',
    canActivate: [canActivateAuthRole],
    loadChildren: () => import('O3_notifications').then((c) => c.routes),
  },
  {
    path: 'pathological-anatomy',
    canActivate: [canActivateAuthRole],
    loadChildren: () => import('O3_pathological-anatomy').then((c) => c.routes),
  },
  {
    path: 'template-manager',
    canActivate: [canActivateAuthRole],
    loadChildren: () => import('O3_template-manager').then((c) => c.routes),
  },
  {
    path: 'audit',
    canActivate: [canActivateAuthRole],
    providers: GLOBAL_AUDIT_PROVIDERS,
    loadChildren: () => import('O3_audit').then((c) => c.routes),
  },
  {
    path: 'communication',
    canActivate: [canActivateAuthRole],
    loadChildren: () => import('O3_communication').then((c) => c.routes),
  },
  {
    // Authentication only — "My tickets" must be reachable by every user.
    // The console's own routes carry the support scope guards.
    path: 'support',
    canActivate: [canActivateAuthRole],
    loadChildren: () => import('O3_support').then((c) => c.routes),
  },
  {
    path: 'forbidden',
    canActivate: [canActivateAuthRole],
    component: Forbidden,
  },
  { path: 'not-found', component: PageNotFound },
  { path: '**', redirectTo: '/not-found' },
];
